/* Breskvica – market stil: male dorade na stranici */
(function () {
  var FREE = 400000; // 4.000 RSD u parama
  /* cena iz teksta: radi i za "1,990.00 RSD" i za "1.990,00 RSD" i za "990 RSD" */
  var num = function (t) {
    var s = String(t || '').replace(/[^\d.,]/g, ''), m = s.match(/[.,](\d{1,2})$/);
    if (m) return parseFloat(s.slice(0, -m[0].length).replace(/[.,]/g, '') + '.' + m[1]);
    return parseFloat(s.replace(/[.,]/g, ''));
  };

  /* dodatni stilovi */
  var css = '.bk-free{display:inline-flex;align-items:center;gap:5px;margin-top:4px;font-family:var(--font-body-family);font-size:1.2rem;font-weight:700;color:#23814A}' +
    '.bk-free::before{content:"";width:6px;height:6px;border-radius:50%;background:#2F9E5B}' +
    '.es-button:not([data-bk]){animation:bkHide 1.5s step-end}@keyframes bkHide{from{opacity:0}to{opacity:0}}' +
    '.product-card-wrapper .quick-add__submit.button{min-height:4rem!important;font-size:1.35rem!important}' +
    '@media (min-width:990px){[id$="__bkm_header"]{position:sticky;top:0;z-index:40}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* --- procenat popusta na oznakama --- */
  function pct(pr) {
    var r = pr.querySelector('s.price-item--regular') || pr.querySelector('.price__sale .price-item--regular');
    var s = pr.querySelector('.price__sale .price-item--sale') || pr.querySelector('.price-item--sale');
    if (!r || !s) return 0;
    var p = Math.round((1 - num(s.textContent) / num(r.textContent)) * 100);
    return p > 0 && p < 100 ? p : 0;
  }
  function badges() {
    document.querySelectorAll('.price--on-sale').forEach(function (pr) {
      var p = pct(pr); if (!p) return;
      var sc = pr.closest('.card-wrapper') || pr;
      sc.querySelectorAll('.badge').forEach(function (b) {
        var t = '-' + p + '%';
        if (!/rasprodat|sold|nema/i.test(b.textContent) && b.textContent.trim() !== t) b.textContent = t;
      });
    });
  }

  /* --- "Pogledaj sve" pored naslova sekcije --- */
  function viewall() {
    document.querySelectorAll('.collection').forEach(function (s) {
      var a = s.querySelector('.collection__view-all a'), t = s.querySelector('.collection__title');
      if (!a || !t || t.querySelector('.bkm-viewall')) return;
      var n = document.createElement('a');
      n.href = a.getAttribute('href'); n.className = 'bkm-viewall'; n.textContent = 'Pogledaj sve';
      t.appendChild(n);
    });
  }

  /* --- EasySell "Kupi odmah" dugme u nasim bojama --- */
  var ES = { 'background': '#FF7A45', 'background-image': 'none', 'color': '#fff', 'border': '0', 'border-radius': '12px', 'box-shadow': 'none', 'width': '100%', 'max-width': '100%', 'margin-left': '0', 'margin-right': '0', 'box-sizing': 'border-box', 'font-family': "'Figtree',system-ui,sans-serif", 'font-weight': '700' };
  function es() {
    document.querySelectorAll('.es-button').forEach(function (b) {
      if (b.dataset.bk) return; b.dataset.bk = '1';
      for (var k in ES) b.style.setProperty(k, ES[k], 'important');
      if (b.closest('.product')) b.style.setProperty('min-height', '54px', 'important');
      b.querySelectorAll('*').forEach(function (x) {
        x.style.setProperty('color', '#fff', 'important');
        x.style.setProperty('font-family', "'Figtree',system-ui,sans-serif", 'important');
      });
    });
  }

  /* --- traka do besplatne dostave --- */
  var SHIP = '<div class="bk-ship" data-bk-ship hidden><p class="bk-ship-t"></p><div class="bk-ship-bar"><i></i></div></div>';
  var money = function (v) { return Math.ceil(v / 100).toLocaleString('sr-RS') + ' din'; };
  function shipSlots() {
    var cn = document.querySelector('#cart-notification .cart-notification__links');
    if (cn && !document.querySelector('#cart-notification [data-bk-ship]')) cn.insertAdjacentHTML('beforebegin', SHIP);
    var cd = document.querySelector('cart-drawer .drawer__header');
    if (cd && !document.querySelector('cart-drawer [data-bk-ship]')) cd.insertAdjacentHTML('afterend', SHIP);
  }
  function renderShip(cart) {
    var tot = cart.total_price || 0, left = FREE - tot, w = Math.min(100, tot / FREE * 100);
    document.querySelectorAll('[data-bk-ship]').forEach(function (el) {
      el.hidden = tot === 0;
      el.classList.toggle('is-done', left <= 0);
      el.querySelector('.bk-ship-t').innerHTML = left > 0
        ? 'Dodajte još <b>' + money(left) + '</b> i dostava je <b>besplatna</b>'
        : '<b>Imate besplatnu dostavu!</b>';
      el.querySelector('i').style.width = w + '%';
    });
  }
  function loadShip() {
    shipSlots();
    if (!document.querySelector('[data-bk-ship]')) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(renderShip).catch(function () {});
  }
  var of = window.fetch;
  window.fetch = function (u) {
    var url = String(u && u.url ? u.url : u), p = of.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(loadShip, 250); }).catch(function () {});
    return p;
  };

  /* --- donja traka "Kupi odmah" na telefonu --- */
  function sticky() {
    var bar = document.getElementById('bkp-sticky');
    if (!bar || bar.dataset.bk) return; bar.dataset.bk = '1';
    var anchor = document.querySelector('.product .product-form__buttons') || document.querySelector('.product .product-form');
    if (!anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', show);
    }).observe(anchor);
    bar.querySelector('button').addEventListener('click', function () {
      var t = document.querySelector('.product .es-button') || document.querySelector('.product .product-form__submit');
      if (t) t.click(); else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* --- oznaka "Besplatna dostava" na karticama od 4.000 din --- */
  function freeTag() {
    document.querySelectorAll('.product-card-wrapper .price').forEach(function (pr) {
      if (pr.dataset.bkf) return; pr.dataset.bkf = '1';
      var el = pr.querySelector('.price__sale .price-item--sale') || pr.querySelector('.price__regular .price-item--regular');
      if (el && num(el.textContent) >= FREE / 100) pr.insertAdjacentHTML('afterend', '<span class="bk-free">Besplatna dostava</span>');
    });
  }

  function run() { viewall(); badges(); es(); shipSlots(); sticky(); freeTag(); }
  document.addEventListener('DOMContentLoaded', function () { run(); loadShip(); });
  window.addEventListener('load', run);
  var tm;
  new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(run, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], .quick-add__submit, cart-remove-button')) setTimeout(loadShip, 900);
  });
})();
